// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_l1-0";